import { createContext } from 'react';
import { LOCALES, Locale } from './localisation';

interface Store {
  localisation: [Locale, (locale: Locale) => void];
  location: [string | null, (location: string | null) => void];
  assetsData?: any | null;
  translation: Record<string, any>;
  overlay: [() => void, () => void];
  loader: [() => void, () => void];
}

export const StoreContext = createContext<Store>({
  translation: {},
  localisation: [LOCALES.ENG, () => {}],
  overlay: [() => {}, () => {}],
  loader: [() => {}, () => {}],
  location: [null, () => {}],
});
